import { Component, OnInit, Input, ElementRef, ViewChild, AfterViewInit, AfterViewChecked } from '@angular/core';
import { Storage } from 'src/app/models/storage';
import { Subscription } from 'rxjs';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { StorageService } from 'src/app/services/storage.service';
import { MatDialog } from '@angular/material';
import { EdgeDialogComponent } from '../dialogs/edge-dialog/edge-dialog.component';
import _ from 'lodash';
import { AccordionService } from 'src/app/services/accordion.service';

@Component({
  selector: 'app-standard-window',
  templateUrl: './standard-window.component.html',
})
export class StandardWindowComponent
implements OnInit, AfterViewInit, AfterViewChecked {

  // @ViewChild('windowImageCanvas') windowImageCanvas:ElementRef;
  @ViewChild('windowImageCanvas', null) windowImageCanvas: ElementRef<HTMLCanvasElement>;
  @ViewChild('bigWindowImage', null) bigWindowImage: ElementRef<HTMLElement>;

  width: number;
  height: number;
  form: FormGroup;
  subscription: Subscription;
  storage: Storage;
  @Input() windowKey: number;
  flag = 0;

  windowBorderPoints = [
    {x: 36, y: 19},
    {x: 324, y: 19},
    {x: 324, y: 325},
    {x: 36, y: 325},
  ];
  private arrowLength = 40;
  private arrowheadLength = 15;
  private arrowheadWidth = 10;
  private lineThickness = 4;

  mainColor = 'blue';
  secondaryColor = 'yellow';

  windowBorderLabels = [
    {start: {x: 250, y: 19}, end: {x: 250, y: 19 + this.arrowLength}, text: 'GÓRNA KRAWĘDŹ', textPos: {x: 0 , y: 0} },
    {start: {x: 324, y: 180}, end: {x: 324  - this.arrowLength, y: 180}, text: 'PRAWA KRAWĘDŹ', textPos: {x: 0 , y: 0} },
    {start: {x: 250, y: 325}, end: {x: 250, y: 325 - this.arrowLength}, text: 'DOLNA KRAWĘDŹ', textPos: {x: 0 , y: 0} },
    {start: {x: 36, y: 210}, end: {x: 36 + this.arrowLength, y: 210}, text: 'LEWA KRAWĘDŹ', textPos: {x: 0 , y: 0} },
  ];
  windowBackgroundOffset = {left: 0, top: 0};
  canvasScale = 1;
  originalBackgroundSize = {width: 0, height: 0};

  isSameDepth = false;
  depth: number;
  side: 'INSIDE' | 'OUTSIDE';
  sideChanged = false;

  constructor(
    private fb: FormBuilder,
    private storageService: StorageService,
    public dialog: MatDialog,
    private accordionService: AccordionService
  ) { }

  ngOnInit() {
    this.storage = this.storageService.storage;
    this.storageSubscription();
    switch (this.storage.systemType) {
      case 1:
        this.mainColor = '#a9a9a9';
        this.secondaryColor = '#dbdbdb';
        break;
      case 2:
        this.mainColor = '#364f91';
        this.secondaryColor = '#6173a3';
        break;
      case 3:
        this.mainColor = '#648f62';
        this.secondaryColor = '#a2bca1';
        break;
    }
  }

  ngAfterViewInit() {
    this.init();
  }

  ngAfterViewChecked() {
    if (this.sideChanged) {
      this.init();
      this.sideChanged = false;
    } else if (
      this.bigWindowImage.nativeElement.offsetHeight !== this.height ||
      this.bigWindowImage.nativeElement.offsetWidth !== this.width) {
      this.resize();
    }
    // console.log('sss')
  }

  private storageSubscription() {
    this.subscription = this.storageService.storage$.subscribe(async (data) => {
      this.storage = data;

      if (this.storage.windows[this.windowKey] === undefined ) {
        return false;
      }

      this.side = this.storage.windows[this.windowKey].standard.side;
      this.isSameDepth = this.storage.windows[this.windowKey].standard[this.getSideName(this.side)].isSameDepth;
      this.depth = this.storage.windows[this.windowKey].standard[this.getSideName(this.side)].depth;
    });
  }

  init() {
    this.width = this.bigWindowImage.nativeElement.offsetWidth;
    this.height = this.bigWindowImage.nativeElement.offsetHeight;
    this.windowImageCanvas.nativeElement.setAttribute('width', this.width.toString());
    this.windowImageCanvas.nativeElement.setAttribute('height', this.height.toString());

    const windowImage = new Image();
    const self = this;
    windowImage.onload = () => {
      self.originalBackgroundSize.width = windowImage.width;
      self.originalBackgroundSize.height = windowImage.height;

      self.recalculateScale();
      self.recalculateOffset();

      self.fillCanvas();
    };
    if (this.side === 'OUTSIDE') {
      windowImage.src = 'assets/images/windowOutside.png';
    } else if (this.side === 'INSIDE') {
      windowImage.src = 'assets/images/windowInside.png';
    }
    this.windowImageCanvas.nativeElement.addEventListener('mousemove', (e) => {
      const point = {
        x: (e.offsetX + self.windowBackgroundOffset.left / 2) / self.canvasScale,
        y: (e.offsetY + self.windowBackgroundOffset.top / 2) / self.canvasScale
      };

      const edge = self.checkIfOnLine(point.x, point.y, self.windowBorderPoints);

      const arrow = self.checkIfOnArrow(point.x, point.y, self.windowBorderLabels);

      const text = self.checkIfOnText(point.x, point.y, self.windowBorderLabels);


      if ( edge ) {
        self.windowImageCanvas.nativeElement.style.cursor = 'pointer';
        self.fillCanvas([edge.i, edge.j]);
      } else if ( arrow !== null ) {
        self.windowImageCanvas.nativeElement.style.cursor = 'pointer';
        self.fillCanvas([arrow.i, arrow.j]);
      } else if ( text !== null ) {
        self.windowImageCanvas.nativeElement.style.cursor = 'pointer';
        self.fillCanvas([text.i, text.j]);
      } else {
        self.windowImageCanvas.nativeElement.style.cursor = 'default';
        self.fillCanvas();
      }


    });

    this.windowImageCanvas.nativeElement.addEventListener('click', (e) => {
      const point = {
        x: (e.offsetX + self.windowBackgroundOffset.left / 2) / self.canvasScale,
        y: (e.offsetY + self.windowBackgroundOffset.top / 2) / self.canvasScale
      };

      const edge = self.checkIfOnLine(point.x, point.y, self.windowBorderPoints);
      const arrow = self.checkIfOnArrow(point.x, point.y, self.windowBorderLabels);
      const text = self.checkIfOnText(point.x, point.y, self.windowBorderLabels);

      let result = null;
      if ( edge ) {
        result = edge;
      } else if ( arrow ) {
        result = arrow;
      } else if ( text ) {
        result = text;
      }
      if ( result ) {
        if (result.i === 0 && result.j === 1) {
          self.accordionService.canvasEvent = 2;
        } else if (result.i === 1 && result.j === 2) {
          self.accordionService.canvasEvent = 1;
        } else if (result.i === 2 && result.j === 3) {
          self.accordionService.canvasEvent = 3;
        } else if (result.i === 3 && result.j === 0) {
          self.accordionService.canvasEvent = 0;
        } else {
          self.accordionService.canvasEvent = null;
        }
      } else {
        self.accordionService.canvasEvent = null;
      }

    });
  }

  resize() {
    this.width = this.bigWindowImage.nativeElement.offsetWidth;
    this.height = this.bigWindowImage.nativeElement.offsetHeight;
    this.windowImageCanvas.nativeElement.setAttribute('width', this.width.toString());
    this.windowImageCanvas.nativeElement.setAttribute('height', this.height.toString());

    this.recalculateScale();
    this.recalculateOffset();
    this.fillCanvas();

  }


  private recalculateScale() {

    if (this.width / this.originalBackgroundSize.width < this.height / this.originalBackgroundSize.height) {
      this.canvasScale = this.width / this.originalBackgroundSize.width;
    } else {
      this.canvasScale = this.height / this.originalBackgroundSize.height;
    }
  }

  private recalculateOffset() {
    this.windowBackgroundOffset.left = this.originalBackgroundSize.width * this.canvasScale - this.width;
    this.windowBackgroundOffset.top = this.originalBackgroundSize.height * this.canvasScale - this.height;

  }

  private fillCanvas(highlight = null) {
    const canvas: HTMLCanvasElement = this.windowImageCanvas.nativeElement;
    const ctx = canvas.getContext('2d');

    ctx.clearRect(0, 0, this.width, this.height);

    this.drawShape(ctx , this.windowBorderPoints, null, this.mainColor, 5, true);

    for (const label of this.windowBorderLabels ) {
      this.drawArrow(ctx, label.start, label.end);
      this.drawLabel(ctx, label.text, label.start, label.end);
    }

    if (highlight) {
      const highlightLine = [this.windowBorderPoints[highlight[0]], this.windowBorderPoints[highlight[1]]];
      this.drawShape(ctx , highlightLine, null, this.secondaryColor, 3, false);
      this.drawArrow(
        ctx,
        this.windowBorderLabels[highlight[0]].start,
        this.windowBorderLabels[highlight[0]].end,
        this.secondaryColor,
        this.mainColor
      );
    }
  }

  private drawLabel(ctx, text, start, end) {
    const scale = this.canvasScale;
    const offset = this.windowBackgroundOffset;
    ctx.fillStyle = this.mainColor;
    const fontSize = 14;
    ctx.font = fontSize + 'px Arial';
    const txtLen = ctx.measureText(text).width;
    const margin = 3;
    if (start.x !== end.x) { // >
      if (start.x > end.x) {
        ctx.fillText(text, end.x * scale - offset.left / 2 - txtLen - margin, end.y * scale - offset.top / 2 + fontSize / 2);
      } else {
        ctx.fillText(text, end.x * scale - offset.left / 2 + margin, end.y * scale - offset.top / 2 + fontSize / 2);
      }
    } else if (start.y !== end.y) { // ^
      if (start.y > end.y) {
        ctx.fillText(text, end.x * scale - offset.left / 2 - txtLen / 2, end.y * scale - offset.top / 2 - margin);
      } else {
        ctx.fillText(text, end.x * scale - offset.left / 2 - txtLen / 2, end.y * scale - offset.top / 2 + fontSize + margin);
      }
    }
  }

  private drawArrow(ctx, start, end, fill = this.mainColor, border = 'white') {
    this.drawArrowhead(ctx, start, end, fill, border);
    this.drawArrowLine(ctx, start, end, fill, border);
  }

  private drawArrowLine(ctx, start, end, fill = this.mainColor, border = 'white') {
    const lineThickness = this.lineThickness;
    const arrowLineCoordinates = [];
    let direction = 1;
    const offset = this.arrowheadLength - 2;
    if (start.x !== end.x) { // >
      if (start.x > end.x) {
        direction = -1;
      } else {
        direction = 1;
      }
      arrowLineCoordinates.push({x: start.x + direction * offset, y: start.y - lineThickness / 2});
      arrowLineCoordinates.push({x: end.x , y: end.y - lineThickness / 2});
      arrowLineCoordinates.push({x: end.x , y: end.y + lineThickness / 2});
      arrowLineCoordinates.push({x: start.x + direction * offset, y: start.y + lineThickness / 2});
    } else if (start.y !== end.y) { // ^
      if (start.y > end.y) {
        direction = -1;
      } else {
        direction = 1;
      }
      arrowLineCoordinates.push({x: start.x - lineThickness / 2, y: start.y + direction * offset});
      arrowLineCoordinates.push({x: end.x - lineThickness / 2 , y: end.y});
      arrowLineCoordinates.push({x: end.x + lineThickness / 2 , y: end.y});
      arrowLineCoordinates.push({x: start.x + lineThickness / 2, y: start.y + direction * offset});
    }

    this.drawShape(ctx, arrowLineCoordinates, fill, border, 1, false);

  }

  private drawArrowhead(ctx, start, end, fill = this.mainColor, border = 'white') {
    const arrowheadLength = this.arrowheadLength;
    const arrowheadWidth = this.arrowheadWidth;

    const arrowheadCoordinates = [];
    if (start.x !== end.x && start.x > end.x) {
      arrowheadCoordinates.push({x: start.x, y: start.y});
      arrowheadCoordinates.push({x: start.x - arrowheadLength, y: start.y - arrowheadWidth / 2});
      arrowheadCoordinates.push({x: start.x - arrowheadLength, y: start.y + arrowheadWidth / 2});
    } else if (start.x !== end.x && start.x < end.x) {
      arrowheadCoordinates.push({x: start.x, y: start.y});
      arrowheadCoordinates.push({x: start.x + arrowheadLength, y: start.y - arrowheadWidth / 2});
      arrowheadCoordinates.push({x: start.x + arrowheadLength, y: start.y + arrowheadWidth / 2});
    } else if (start.y !== end.y && start.y < end.y) {
      arrowheadCoordinates.push({x: start.x, y: start.y});
      arrowheadCoordinates.push({x: start.x - arrowheadWidth / 2, y: start.y + arrowheadLength});
      arrowheadCoordinates.push({x: start.x + arrowheadWidth / 2, y: start.y + arrowheadLength});
    } else if (start.y !== end.y && start.y > end.y) {
      arrowheadCoordinates.push({x: start.x, y: start.y});
      arrowheadCoordinates.push({x: start.x - arrowheadWidth / 2, y: start.y - arrowheadLength});
      arrowheadCoordinates.push({x: start.x + arrowheadWidth / 2, y: start.y - arrowheadLength});
    }
    this.drawShape(ctx, arrowheadCoordinates, fill, border, 1, true);

  }

  drawShape(ctx, points, fill = null, border = null, borderWidth = 2, close = false) {
    const scale = this.canvasScale;
    const offset = this.windowBackgroundOffset;

    let i = 0;
    ctx.beginPath();
    for (const point of points) {
      if (i === 0) {
        ctx.moveTo(point.x * scale - offset.left / 2, point.y * scale - offset.top / 2);
      } else {
        ctx.lineTo(point.x * scale - offset.left / 2, point.y * scale - offset.top / 2);
      }
      i++;
    }

    if (close) {
      ctx.closePath();
    }

    if (fill) {
      ctx.fillStyle = fill;
      ctx.fill();
    }

    if (border) {
      ctx.lineWidth = borderWidth;
      ctx.strokeStyle = border;
      ctx.stroke();
    }
  }
  checkIfOnText(x, y, labels) {
    let inside = false;
    let index = 0;

    const fontSize = 14;
    const margin = 10;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    ctx.font = fontSize + 'px Arial';

    const scale = this.canvasScale;

    for (const label of labels) {
      const txtLen = ctx.measureText(label.text).width / scale;

      let points = [];
      let point;
      if (label.start.x !== label.end.x) { // >
        if (label.start.x > label.end.x) {
          point = {x: label.end.x - txtLen, y: label.end.y + fontSize / 2};
        } else {
          point = {x: label.end.x, y: label.end.y + fontSize / 2};
        }
      } else if (label.start.y !== label.end.y) { // ^
        if (label.start.y > label.end.y) {
          point = {x: label.end.x - txtLen / 2, y: label.end.y - fontSize / 2};
        } else {
          point = {x: label.end.x - txtLen / 2, y: label.end.y + 2 * fontSize};
        }
      }

      points = [
        [point.x - margin, point.y + margin],
        [point.x + txtLen + margin, point.y + margin],
        [point.x + txtLen + margin, point.y - fontSize - margin],
        [point.x - margin, point.y - fontSize - margin]
      ];

      inside = this.isInside([x, y], points);
      if (inside) {
        break;
      }
      index++;
    }
    const pts = {i: index, j: index + 1};
    if (index === 3) {
      pts.j = 0;
    }

    if (inside) {
      return pts;
    } else {
      return null;
    }

  }

  checkIfOnArrow(x, y, labels) {

    let inside = false;
    let index = 0;
    for (const label of labels) {
      let points = [];
      if (label.start.x === label.end.x) {
        points = [
          [label.start.x - this.lineThickness, label.start.y],
          [label.start.x + this.lineThickness, label.start.y],
          [label.end.x + this.lineThickness, label.end.y],
          [label.end.x - this.lineThickness, label.end.y]
        ];
      } else {
        points = [
          [label.start.x, label.start.y - this.lineThickness],
          [label.start.x, label.start.y + this.lineThickness],
          [label.end.x, label.end.y + this.lineThickness],
          [label.end.x, label.end.y - this.lineThickness]
        ];
      }

      inside = this.isInside([x, y], points);
      if (inside) {
        break;
      }
      index++;
    }
    const pts = {i: index, j: index + 1};
    if (index === 3) {
      pts.j = 0;
    }
    if (inside) {
      return pts;
    } else {
      return null;
    }

  }

  private isInside(point, vs) {
    const x = point[0];
    const y = point[1];

    let inside = false;
    for (let i = 0, j = vs.length - 1; i < vs.length; j = i++) {
        const xi = vs[i][0];
        const yi = vs[i][1];
        const xj = vs[j][0];
        const yj = vs[j][1];

        const intersect = ((yi > y) !== (yj > y))
            && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
        if (intersect) {
          inside = !inside;
        }
    }

    return inside;
  }

  checkIfOnLine(x, y, points ) {
    if (points.length > 1) {
        let minDist = null;
        let a;
        let b;
        let minIndex = null;
        for (let i = 0; i < points.length; i++) {

            if (i < points.length - 1) {
                a = i;
                b = i + 1;
            } else {
                a = i;
                b = 0;
            }

            const point1 = points[a];
            const point2 = points[b];


            const dist = this.pDistance(x, y, point1.x, point1.y, point2.x, point2.y);
            const margin = 20; // data.o.scaleView < 1 ? 10 : 10 / data.o.scaleView;

            if (dist < margin) {

                if (!minDist) {
                    minDist = dist;
                    minIndex = {
                        i: a,
                        j: b
                    };
                } else if (minDist > dist) {
                    minDist = dist;
                    minIndex = {
                        i: a,
                        j: b
                    };
                }
            } else {
            }

        }
        return minIndex;
    }
  }

  // --------------------------------------------------------------------------
  // odleglosc punktu @x@y od odcinka @x1@y1-@x2-@y2
  // --------------------------------------------------------------------------
  pDistance(x, y, x1, y1, x2, y2) {

    const A = x - x1;
    const B = y - y1;
    const C = x2 - x1;
    const D = y2 - y1;

    const dot = A * C + B * D;
    const lenSq = C * C + D * D;
    let param = -1;
    if (lenSq !== 0) { // in case of 0 length line
        param = dot / lenSq;
    }
    let xx;
    let yy;

    if (param < 0) {
        xx = x1;
        yy = y1;
    } else if (param > 1) {
        xx = x2;
        yy = y2;
    } else {
        xx = x1 + param * C;
        yy = y1 + param * D;
    }

    const dx = x - xx;
    const dy = y - yy;

    return Math.sqrt(dx * dx + dy * dy);
  }

  changeIsSameDepth(event: any) { // type matchange checkbox
    const storage = this.storage;
    storage.windows[this.windowKey].standard[this.getSideName(this.side)].isSameDepth = event.checked;

    this.storageService.storage = storage;
  }

  changeAreOutsideEdgesSameAsInsideEdges() {
    const storage = this.storage;
    storage.windows[this.windowKey].standard.outside = _.cloneDeep(storage.windows[this.windowKey].standard.inside);

    this.storageService.storage = storage;
  }

  handleAddDepthDialog(type: string, index: number) {
    const data = {
      depth: this.depth,
    };

    const dialogRef = this.dialog.open(EdgeDialogComponent, {
      width: '640px',
      panelClass: 'selena-calculator',
      data: {
        type,
        index,
        data,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.status === 'OK') {
        const storage = _.cloneDeep(this.storage);
        storage.windows[this.windowKey].standard[this.getSideName(this.side)].depth = result.data.depth;

        this.storageService.storage = this.setEdgesDepth(storage, result.data.depth);
      }
    });
  }

  setEdgesDepth(storage, depth) {
    const edges = storage.windows[this.windowKey].standard[this.getSideName(this.side)].edges;
    for (let i = 0; i < edges.length; i++) {
      storage.windows[this.windowKey].standard[this.getSideName(this.side)].edges[i].depth = depth;
    }
    return storage;
  }

  setWindowSide(side: string) {
    const storage = this.storage;
    storage.windows[this.windowKey].standard.side = side;

    this.storageService.storage = storage;

    this.sideChanged = true;
  }

  getSideName(staticName: string) {
    switch (staticName) {
      case 'INSIDE':
        return 'inside';
      case 'OUTSIDE':
        return 'outside';
    }
  }
}
